var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isValidElement } from 'react';
import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import ToastBody from '../container/Ui/Toast/ToastBody';
import ToastUploadBody from '../container/Ui/Toast/ToastUploadBody';
import { logError } from './logger';
/**
 * 非同期のactionをdispatchする
 * @deprecated TS版（@/utils/actions/dispatch.ts）のwrapDispatch利用してください
 * @param dispatch
 * @param action
 * @returns {Promise<unknown>}
 */
export const wrapDispatch = (dispatch, action) => new Promise((resolve, reject) => {
    dispatch(Object.assign(Object.assign({}, action), { meta: Object.assign(Object.assign({}, action.meta), { reject,
            resolve }) }));
});
// react-toastify用のoptions
const TOAST_DEFAULT_OPTIONS = {
    autoClose: 5000,
    closeOnClick: true,
    draggable: false,
    hideProgressBar: true,
    pauseOnHover: true,
    position: 'bottom-left',
};
/**
 * 通常のtoastを表示
 * @param content
 * @param options
 * @returns {React.ReactText}
 */
export const notify = (content, options = {}) => toast(_jsx(ToastBody, { content: content, type: 'info' }), Object.assign(Object.assign({}, TOAST_DEFAULT_OPTIONS), options));
/**
 * アップロードプログレス用のtoastを表示
 * @param progress
 * @param options
 * @returns {React.ReactText}
 */
export const notifyUploading = (progress, options = {}) => toast(_jsx(ToastUploadBody, { progress: progress }), Object.assign(Object.assign(Object.assign({}, TOAST_DEFAULT_OPTIONS), { autoClose: progress === 100 ? 3000 : false, className: 'uploading_inner', closeButton: false, position: 'bottom-center' }), options));
/**
 * アップロードプログレス用のtoastを更新する
 * @param toastId
 * @param progress
 * @param options
 */
export const updateNotifyUploading = (toastId, progress, options = {}) => toast.update(toastId, Object.assign({ autoClose: progress === 100 ? 3000 : false, render: _jsx(ToastUploadBody, { progress: progress }) }, options));
/**
 * エラー用のtoastを表示する
 * @param content {React.ReactNode|null}
 * @param options
 * @returns {React.ReactText}
 */
export const notifyError = (content = null, options = {}) => toast(_jsx(ToastBody, { content: content, type: 'error' }), Object.assign(Object.assign({}, TOAST_DEFAULT_OPTIONS), options));
/**
 * idに対応するtoastを更新する
 * @param toastId
 * @param options
 */
export const updateNotify = (toastId, options = {}) => {
    toast.update(toastId, options);
};
/**
 * idに対応するtoastを非表示にする
 * @param toastId
 */
export const deleteNotify = (toastId) => {
    toast.dismiss(toastId);
};
export const wrapNotifyError = (callback) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield callback();
    }
    catch (e) {
        logError(e);
        if (isValidElement(e)) {
            notifyError(e);
            // バリデーションエラーの場合は握り潰さないように
        }
        else if (e instanceof SubmissionError) {
            throw e;
        }
        else {
            notifyError();
        }
    }
});
